import { getFunctions, httpsCallable, connectFunctionsEmulator } from 'firebase/functions';
import app, { isLocalEmulator } from '../../firebase';
import { readPrivateFinancials } from './financialService';
let functions;
export async function processShiftPayroll(shiftId, action) {
  if (!functions) {
    functions = getFunctions(app, 'us-central1');
    if (isLocalEmulator) connectFunctionsEmulator(functions, '127.0.0.1', 5001);
  }
  const result = await httpsCallable(functions, 'processShiftPayroll')({ shiftId, action });
  const financial = await readPrivateFinancials('shifts', shiftId);
  return { ...result.data, financial };
}
